// extracted by mini-css-extract-plugin
export default {"notification":"WS1gyOeNyculFi9dDdIH"};